import {
    GET_ALL_ORDERS,
    UPDATE_SELECTED_ORDER,
    SET_ACTIVE_ORDER_MODAL_DIMENSIONS,
    CLEAR_ACTIVE_DELIVERY_ORDER,
    CLEAR_SELECTED_ORDER
} from '../constants';

export const getAllOrders = (orders) => ({
    type: GET_ALL_ORDERS,
    orders
});

export const updateSelectedOrder = (order) => ({
    type: UPDATE_SELECTED_ORDER,
    order
});

export const updateActiveDeliveryOrder = (order, height) => ({
    type: SET_ACTIVE_ORDER_MODAL_DIMENSIONS,
    order,
    height,
});

export const clearActiveDeliveryOrder = () => ({
    type: CLEAR_ACTIVE_DELIVERY_ORDER
});

export const clearSelectedOrder = () => ({
    type: CLEAR_SELECTED_ORDER
})
